import React from 'react'
import './footer.module.css';
import { HashLink as Link } from 'react-router-hash-link';
import classes from './footer.module.css';

function Footer() {
    return (
        <footer className="site-footer" id="contact">
          <div className="container">
            <div className="row">
              <div className=" col-sm-12 col-md-8">
                  <div className={classes.head}>
                <h6>Contact Me</h6>
                </div>
                <p className="text-justify">If Anyone wants to Contact me please contact me on my mail <a href="https://www.google.com/gmail/">harsh.Swami0@gmail.com </a> <i>  </i> If you are a Recruiter i would love to get a chance for an Interview . Also here i have mentioned only some of my projects i have done projects where in i have created full stack applications it was difficult for me to post all my projects beacuse of the backend aspect of the application .</p>
              </div>
              {/* <div className="col-xs-6 col-md-3">
                <h6>Categories</h6>
                <ul className="footer-links">
                  <li><a href="http://scanfcode.com/category/c-language/">C</a></li>
                  <li><a href="http://scanfcode.com/category/front-end-development/">UI Design</a></li>
                  <li><a href="http://scanfcode.com/category/back-end-development/">PHP</a></li>
                  <li><a href="http://scanfcode.com/category/java-programming-language/">Java</a></li>
                  <li><a href="http://scanfcode.com/category/android/">Android</a></li>
                  <li><a href="http://scanfcode.com/category/templates/">Templates</a></li>
                </ul>
              </div> */}
              <div className="col-xs-3 col-md-3 col-sm-12">
                <h6>Quick Links</h6>
                <ul className="footer-links">
                    <li ><Link smooth to="/#about" className="footer-links">About</Link></li>
                    <li ><Link smooth to="/#education" className="footer-links" >Education</Link></li>
                    <li ><Link smooth to="/#interest" className="footer-links">Interest</Link></li>
                    <li ><Link smooth to="/#projects" className="footer-links">Projects</Link></li>
                    <li ><Link smooth to="/#contact" className="footer-links">Contact</Link></li>
                    {/* <li className="sidebar-nav-items"><a href="http://www.bloggingpeek.com" target="_blank" rel="opener noreferrer" className="links"> Blog<FiExternalLink/></a></li> */}
                </ul>
              </div>
            </div>
            <hr />
          </div>
        </footer>
      );
    }

export default Footer;